import _ from 'lodash'
import type { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { MediaQuery } from '../../../theme/base'

export const StyledRowWrapper = styled.div<
  {
    fullViewCustomWidth?: number
    isLastItem?: boolean
    clickable?: boolean
    fullViewMediaquery?: MediaQuery
    isEmpty?: boolean
  } & HTMLAttributes<HTMLDivElement>
>`
  padding: 8px 0px;
  user-select: none;
  width: 100%;

  ${({ isLastItem, isEmpty, theme }) =>
    !isLastItem &&
    !isEmpty &&
    `
      border-bottom: 1px solid ${theme.colors.gray7};
    `};
  ${({ clickable }) =>
    clickable &&
    ` 
      cursor: pointer;
    `}
  ${({ fullViewMediaquery, fullViewCustomWidth, theme }) => {
    return !_.isNil(fullViewMediaquery) && !_.isNil(fullViewCustomWidth)
      ? `
  ${theme.mediaQueries[fullViewMediaquery]} {
   width: 100%;
   min-width: ${fullViewCustomWidth}px;
  }
  `
      : `width: 100%`
  }}
`
